import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getRoute } from '../Selectors'
import { useDispatch, useSelector } from 'react-redux'
import { clearRoute } from '../ActionCreators'

/**
 * Listener for state route changes from dispatched actions. As opposed to
 * directly to useHistory().push.
 * Main purpose is for separation of concerns when implementing sagas and
 * other non-component functional blocks
 *
 * USAGE: dispatch(setRoute('/my-path', params))
 */
const VNRoutes = () => {
  const dispatch = useDispatch()
  const { push } = useHistory()
  const { route, params } = useSelector((state) => getRoute(state))

  useEffect(() => {
    if (route === null) {
      return
    }
    dispatch(clearRoute())
    push(route, params)
  }, [dispatch, push, params, route])

  return null
}

export default VNRoutes
